// export const prt = "http://localhost:5000";
export const prt = "https://gsentiser.vercel.app";